<template>
    <div>
        <v-data-table
            dense
            :header-props="{
                sortIcon: null,
            }"
            :headers="tableHeader"
            :items="data"
            :items-per-page="-1"
            fixed-header
            height="450"
            :customSort="(item) => item"
            :loading="loading"
            :items-per-page.sync="offset"
            :page.sync="currentPage"
            :server-items-length="dataAmount"
            :footer-props="{
                pagination: {
                    page: currentPage,
                    itemsPerPage: offset,
                    pageStart: (currentPage - 1) * offset,
                    pageStop: currentPage * offset,
                    pageCount: Math.ceil(dataAmount / offset),
                    itemsLength: dataAmount,
                },
                'items-per-page-text': '',
                'items-per-page-options': [15, 20, 30],
            }"
            :class="{
                'fix-first-col': true,
                'fix-last-col': true,
            }"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
        >
            <template v-slot:header.login="{ header }">
                {{ header.text }}
                <v-menu
                    v-model="loginSearchMenu"
                    offset-y
                    :close-on-content-click="false"
                    top
                >
                    <template v-slot:activator="{ on, attrs }">
                        <v-icon
                            small
                            v-bind="attrs"
                            v-on="on"
                            @click.prevent="onSearch('loginSearch')"
                            id="loginSearch"
                        >
                            mdi-magnify
                        </v-icon>
                    </template>
                    <div style="background-color: #1e1e1e; width: 280px">
                        <v-text-field
                            v-model="loginSearch"
                            class="px-4"
                            type="text"
                            ref="loginSearch"
                            :label="$t('alertHub.enterToSearch')"
                            style="width: 100%"
                            single-line
                            hide-details
                        ></v-text-field>
                        <v-btn
                            @click="
                                handleChange();
                                loginSearchMenu = false;
                            "
                            small
                            text
                            color="primary"
                            class="ml-2 mb-2"
                            style="padding: 6px"
                        >
                            {{ $t("common.word.search") }}
                        </v-btn>
                        <v-btn
                            @click="
                                loginSearch = '';
                                handleChange();
                                loginSearchMenu = false;
                            "
                            small
                            text
                            color="red"
                            class="ml-2 mb-2"
                            style="padding: 6px"
                        >
                            {{ $t("common.form.clean") }}
                        </v-btn>
                    </div>
                </v-menu>
            </template>
            <template v-slot:header.book="{ header }">
                {{ header.text }}
                <v-menu
                    v-model="bookFilterMenu"
                    offset-y
                    :close-on-content-click="false"
                    bottom
                >
                    <template v-slot:activator="{ on, attrs }">
                        <v-icon small v-bind="attrs" v-on="on" id="bookFilter">
                            mdi-filter
                        </v-icon>
                    </template>
                    <div style="background-color: #1e1e1e; width: 220px">
                        <v-list dense>
                            <v-list-item
                                v-for="option in bookOptions"
                                :key="option"
                                @click="toggleBook(option)"
                            >
                                <v-list-item-action>
                                    <v-checkbox
                                        :input-value="
                                            selectedBooks.includes(option)
                                        "
                                        @click.stop="toggleBook(option)"
                                    ></v-checkbox>
                                </v-list-item-action>
                                <v-list-item-content>
                                    <v-list-item-title>{{
                                        option
                                    }}</v-list-item-title>
                                </v-list-item-content>
                            </v-list-item>
                        </v-list>
                        <v-divider></v-divider>
                        <div class="pa-2">
                            <v-btn
                                @click="
                                    currentPage = 1;
                                    handleChange();
                                    bookFilterMenu = false;
                                "
                                small
                                text
                                color="primary"
                                class="mr-2"
                            >
                                {{ $t("common.form.confirm") }}
                            </v-btn>
                            <v-btn
                                @click="bookFilterMenu = false"
                                small
                                text
                                color="red"
                            >
                                {{ $t("common.form.cancel") }}
                            </v-btn>
                        </div>
                    </div>
                </v-menu>
            </template>
            <template v-slot:header.alertType="{ header }">
                {{ header.text }}
                <v-menu
                    v-model="alertFilterMenu"
                    offset-y
                    :close-on-content-click="false"
                    bottom
                >
                    <template v-slot:activator="{ on, attrs }">
                        <v-icon small v-bind="attrs" v-on="on" id="alertFilter">
                            mdi-filter
                        </v-icon>
                    </template>
                    <div style="background-color: #1e1e1e; width: 220px">
                        <v-list dense>
                            <v-list-item
                                v-for="option in defaultAlertTypes"
                                :key="option"
                                @click="toggleAlert(option)"
                            >
                                <v-list-item-action>
                                    <v-checkbox
                                        :input-value="
                                            selectedAlerts.includes(option)
                                        "
                                        @click.stop="toggleAlert(option)"
                                    ></v-checkbox>
                                </v-list-item-action>
                                <v-list-item-content>
                                    <v-list-item-title>{{
                                        nameMap[option]
                                    }}</v-list-item-title>
                                </v-list-item-content>
                            </v-list-item>
                        </v-list>
                        <v-divider></v-divider>
                        <div class="pa-2">
                            <v-btn
                                @click="
                                    currentPage = 1;
                                    handleChange();
                                    alertFilterMenu = false;
                                "
                                small
                                text
                                color="primary"
                                class="mr-2"
                            >
                                {{ $t("common.form.confirm") }}
                            </v-btn>
                            <v-btn
                                @click="alertFilterMenu = false"
                                small
                                text
                                color="red"
                            >
                                {{ $t("common.form.cancel") }}
                            </v-btn>
                        </div>
                    </div>
                </v-menu>
            </template>
            <template v-slot:item.login="{ item }">
                <div class="login-cell">
                    <v-tooltip v-if="item.status === 'ONBOARD'" top>
                        <template v-slot:activator="{ on, attrs }">
                            <span
                                class="onboard-dot"
                                v-bind="attrs"
                                v-on="on"
                            ></span>
                        </template>
                        <span>{{ $t("alertHub.onboard") }}</span>
                    </v-tooltip>
                    <a
                        color="primary"
                        @click="redirectTo('info', item.login, item.server_id)"
                    >
                        {{
                            serverOptions.find(
                                (data) => data.id === item.server_id
                            ).server_name +
                            ": " +
                            item.login
                        }}
                    </a>
                </div>
            </template>
            <template v-slot:item.name="{ item }">
                <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                        <span class="name-cell" v-bind="attrs" v-on="on">
                            {{ decodeMaybeHexOrGarbled(item.name) }}
                        </span>
                    </template>
                    <span>{{ decodeMaybeHexOrGarbled(item.name) }}</span>
                </v-tooltip>
            </template>
            <template v-slot:item.book="{ item }">
                {{ JSON.parse(item.book).join(", ") }}
            </template>
            <template v-slot:item.equity="{ item }">
                {{ item.equity.toFixed(2) }}
            </template>
            <template v-slot:item.balance="{ item }">
                {{ item.balance.toFixed(2) }}
            </template>
            <template v-slot:item.margin="{ item }">
                {{ item.margin.toFixed(2) }}
            </template>
            <template v-slot:item.margin_level="{ item }">
                {{ item.margin_level.toFixed(2) }}
            </template>
            <template v-slot:item.vol_opened_in_std_lot="{ item }">
                {{ item.vol_opened_in_std_lot.toFixed(2) }}
            </template>
            <template v-slot:item.open_trades_pnl_usd="{ item }">
                {{ numberWithCommas(item.open_trades_pnl_usd.toFixed(2)) }}
            </template>
            <template v-slot:item.close_pnl_usd="{ item }">
                {{ numberWithCommas(item.close_pnl_usd.toFixed(2)) }}
            </template>
            <template v-slot:item.trigger_time="{ item }">
                {{ item.trigger_time.split(" ")[1] }}
            </template>
            <template v-slot:item.comment="{ item }">
                <span
                    v-if="item.status === 'OFFBOARD'"
                    class="comment-cell"
                    @mouseenter="showCommentTooltip($event, item)"
                    @mouseleave="hideCommentTooltip"
                >
                    {{ item.comment }}
                </span>
                <span v-else
                    ><v-tooltip top>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn
                                v-bind="attrs"
                                v-on="on"
                                icon
                                color="primary"
                                x-small
                                @click="
                                    redirectTo(
                                        'comment',
                                        null,
                                        null,
                                        null,
                                        item
                                    )
                                "
                            >
                                <v-icon> mdi-comment-plus </v-icon>
                            </v-btn>
                        </template>
                        <span>{{ $t("alertHub.watchlistDetailTooltip") }}</span>
                    </v-tooltip>
                </span>
            </template>
            <template v-slot:item.alertType="{ item }">
                <a color="primary" @click="showAlertModal(item)">
                    {{ nameMap[item.alert_type] }}
                </a>
            </template>
            <template v-slot:item.time_decay_status="{ item }">
                <div
                    :style="{
                        color:
                            item.time_decay_status == 'toxic'
                                ? '#f95518'
                                : 'white',
                    }"
                >
                    {{ item.time_decay_status }}
                </div>
            </template>
            <template v-slot:item.alert_level="{ item }">
                <span :class="alertLevelClass(item.alert_level)">
                    {{ "L" + convertAlertLevel(item.alert_level) }}
                </span>
            </template>
            <template v-slot:item.actions="{ item }">
                <span v-if="item.watchlist"
                    ><v-tooltip top>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn
                                v-bind="attrs"
                                v-on="on"
                                icon
                                color="green darken-2"
                                x-small
                                :disabled="!item.watchlist"
                                @click="
                                    redirectTo(
                                        'view',
                                        item.login,
                                        item.server_id,
                                        item.watchlist
                                    )
                                "
                            >
                                <v-icon> mdi-eye </v-icon>
                            </v-btn>
                        </template>
                        <span>{{ $t("alertHub.watchlistDetailTooltip") }}</span>
                    </v-tooltip>
                </span>
                <span v-else
                    ><v-tooltip top>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn
                                v-bind="attrs"
                                v-on="on"
                                icon
                                color="yellow darken-2"
                                x-small
                                :disabled="!!item.watchlist"
                                @click="
                                    redirectTo(
                                        'add',
                                        item.login,
                                        item.server_id
                                    )
                                "
                            >
                                <v-icon> mdi-plus</v-icon>
                            </v-btn>
                        </template>
                        <span>{{ $t("alertHub.addToWatchlist") }}</span>
                    </v-tooltip>
                </span>
                <span
                    ><v-tooltip top>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn
                                v-bind="attrs"
                                v-on="on"
                                icon
                                color="orange darken-2"
                                x-small
                                :disabled="!item.watchlist"
                                @click="redirectTo('edit', item.login)"
                            >
                                <v-icon> mdi-pencil</v-icon>
                            </v-btn>
                        </template>
                        <span>{{ $t("alertHub.editWatchlist") }}</span>
                    </v-tooltip>
                </span>
            </template>
        </v-data-table>

        <AlertDisplayModal
            :alertModal="alertModal"
            :alertDetail="alertDetail"
            :closeModal="
                () => {
                    alertModal = false;
                }
            "
        />
        <WatchlistDisplayModal
            :watchlistModal="watchlistModal"
            :watchlistData="watchlistData"
            :closeModal="
                () => {
                    watchlistModal = false;
                }
            "
        />
        <v-dialog
            :hide-overlay="true"
            :persistent="true"
            v-model="commentModal"
            width="800"
        >
            <v-card class="pt-0">
                <v-app-bar
                    flat
                    color="rgba(0, 0, 0, 0)"
                    style="background: rgb(26, 57, 88)"
                >
                    <v-toolbar-title class="text-h6 white--text pl-0">
                        History Comment Change
                    </v-toolbar-title>
                    <v-spacer></v-spacer>

                    <v-btn color="white" icon @click="commentModal = false"
                        ><v-icon>mdi-close</v-icon></v-btn
                    >
                </v-app-bar>

                <v-card-actions>
                    <v-row>
                        <v-col cols="3" class="pt-2">
                            <div
                                style="
                                    display: flex;
                                    align-items: start;
                                    height: 100%;
                                "
                            >
                                {{ $t("common.table.lastCommentBy") }}:
                            </div>
                        </v-col>
                        <v-col cols="9" class="pb-0">
                            {{ commentData.last_comment_by }}
                        </v-col>
                        <v-col cols="3" class="pt-2">
                            <div
                                style="
                                    display: flex;
                                    align-items: start;
                                    height: 100%;
                                "
                            >
                                {{ $t("common.table.lastCommentTime") }}:
                            </div>
                        </v-col>
                        <v-col cols="9" class="pb-0">
                            {{ commentData.last_comment_time }}
                        </v-col>
                        <v-col cols="3" class="pt-2">
                            <div
                                style="
                                    display: flex;
                                    align-items: start;
                                    height: 100%;
                                "
                            >
                                {{ $t("common.table.lastComment") }}:
                            </div>
                        </v-col>
                        <v-col cols="9" class="pb-0">
                            <v-textarea
                                v-model="commentData.last_comment"
                                filled
                                rows="2"
                                readonly
                                hide-details
                            ></v-textarea>
                        </v-col>
                        <v-col cols="3" class="pt-2">
                            <div
                                style="
                                    display: flex;
                                    align-items: start;
                                    height: 100%;
                                "
                            >
                                {{ $t("common.table.newComment") }}:
                            </div>
                        </v-col>
                        <v-col cols="9" class="pb-0">
                            <v-textarea
                                v-model="commentData.comment"
                                filled
                                auto-grow
                                rows="2"
                                hide-details
                            ></v-textarea>
                        </v-col>
                    </v-row>
                </v-card-actions>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        color="green darken-1"
                        text
                        @click.stop="() => onCommentChange()"
                        :loading="commentLoading"
                        >{{ $t("common.form.confirm") }}</v-btn
                    >
                </v-card-actions>
            </v-card>
        </v-dialog>
        <div
            v-if="commentTooltip.visible"
            class="comment-tooltip-fixed"
            :style="{
                top: commentTooltip.y + 'px',
                left: commentTooltip.x + 'px',
            }"
        >
            {{ commentTooltip.text }}
        </div>
    </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import {
    getAlertHubUpgradeHistoryData,
    fetchLastComment,
    changeHistoryComment,
} from "@services/alert-hub";
import { helper } from "@components/mixins/helper";
import AlertDisplayModal from "./AlertDisplayModal";
import WatchlistDisplayModal from "@views/alert-hub/WatchlistDisplayModal";
import { snackbar } from "@components/mixins/snackbar";
import deepClone from "deep-clone";
import { redirectToRH } from "@utils/util";

export default {
    mixins: [helper, snackbar],
    components: {
        AlertDisplayModal,
        WatchlistDisplayModal,
    },
    props: {
        serverOptions: Array,
        triggered: Boolean,
        selectedDate: String,
        selectedStatus: String,
        refresh: Boolean,
    },
    data() {
        return {
            commentTooltip: {
                visible: false,
                text: "",
                x: 0,
                y: 0,
            },
            type_mapping: {
                Fast_Close: "fast-trade",
                High_Volume_USD: "high-volume-usd",
                High_Trade_Count: "high-trade-count",
                Large_PNL: "large-pnl",
                Large_Exposure: "large-exposure",
                Cross_Account_Hedging: "cross-account-hedging",
                Low_Liquidity_Arbitrage: "low-liquidity-arbitrage",
                New_Deposit: "new-deposit",
                New_Trade: "new-trade",
            },
            tableHeader: [
                {
                    text: this.$t("common.table.login"),
                    value: "login",
                    align: "left",
                    width: 60,
                },
                {
                    text: this.$t("common.table.name"),
                    value: "name",
                    align: "left",
                    width: 30,
                },
                {
                    text: "Book",
                    value: "book",
                    align: "left",
                    width: 60,
                },
                {
                    text: this.$t("common.table.ccy"),
                    value: "ccy",
                    align: "left",
                    width: 30,
                },
                {
                    text: "Time Decay",
                    value: "time_decay_status",
                    align: "left",
                    width: 30,
                },
                {
                    text: this.$t("common.table.equity"),
                    value: "equity",
                    align: "right",
                    width: 30,
                },
                {
                    text: this.$t("common.table.balance"),
                    value: "balance",
                    align: "right",
                    width: 30,
                },
                {
                    text: this.$t("common.table.leverage"),
                    value: "leverage",
                    align: "right",
                    width: 30,
                },
                {
                    text: this.$t("common.table.margin"),
                    value: "margin",
                    align: "right",
                    width: 30,
                },
                {
                    text: this.$t("common.table.marginLevel"),
                    value: "margin_level",
                    align: "right",
                    width: 30,
                },
                {
                    text: this.$t("common.table.volOpenedInStdLot"),
                    value: "vol_opened_in_std_lot",
                    align: "right",
                    width: 30,
                },
                {
                    text: this.$t("common.table.tradesOpened"),
                    value: "trades_opened",
                    align: "right",
                    width: 30,
                },
                {
                    text: this.$t("common.table.openTradesPnlUsd"),
                    value: "open_trades_pnl_usd",
                    align: "right",
                    width: 30,
                },
                {
                    text: this.$t("common.table.totalPnlUsd"),
                    value: "close_pnl_usd",
                    align: "right",
                    width: 30,
                },
                {
                    text: this.$t("common.table.regDate"),
                    value: "regDate",
                    align: "right",
                    width: 30,
                },
                {
                    text: this.$t("common.table.triggerTime"),
                    value: "trigger_time",
                    align: "right",
                    width: 30,
                },
                {
                    text: this.$t("common.table.comment"),
                    value: "comment",
                    align: "left",
                    sortable: false,
                    width: 30,
                },
                {
                    text: this.$t("common.table.alertType"),
                    value: "alertType",
                    align: "left",
                    sortable: false,
                    width: 30,
                },
                {
                    text: this.$t("common.table.actions"),
                    value: "actions",
                    align: "left",
                    sortable: false,
                    width: 30,
                },
                {
                    text: this.$t("common.table.alertLevel"),
                    value: "alert_level",
                    align: "left",
                    width: 30,
                },
            ],
            data: [],
            loading: false,
            alertDetail: null,
            alertModal: false,
            watchlistModal: false,
            watchlistData: {},
            offset: 15,
            currentPage: 1,
            dataAmount: 0,
            interval: null,
            sortBy: ["trigger_time"],
            sortDesc: true,
            fetchTimeout: null,
            loginSearchMenu: false,
            loginSearch: "",
            alertFilterMenu: false,
            selectedAlerts: [],
            fetched: true,
            defaultAlertTypes: [
                "MSG_TYPE_MONITOR_FAST_CLOSED_TRADE",
                "MSG_TYPE_MONITOR_HIGH_VOLUME_USD",
                "MSG_TYPE_MONITOR_HIGH_TRADE_COUNT",
                "MSG_TYPE_MONITOR_TODAY_OPENED_LARGE_PNL",
                // "Large_Exposure",
                // "Cross_Account_Hedging",
                "MSG_TYPE_MONITOR_LOW_LIQUIDITY_ARBITRAGE",
                // "New_Deposit",
                // "New_Trade",
            ],
            uniqueType: [
                "MSG_TYPE_MONITOR_FAST_CLOSED_TRADE",
                "MSG_TYPE_MONITOR_HIGH_VOLUME_USD",
                "MSG_TYPE_MONITOR_HIGH_TRADE_COUNT",
                "MSG_TYPE_MONITOR_TODAY_OPENED_LARGE_PNL",
                "MSG_TYPE_MONITOR_LOW_LIQUIDITY_ARBITRAGE",
            ],
            nameMap: {
                MSG_TYPE_MONITOR_FAST_CLOSED_TRADE: "Fast Close",
                MSG_TYPE_MONITOR_HIGH_VOLUME_USD: "High Volume USD",
                MSG_TYPE_MONITOR_HIGH_TRADE_COUNT: "High Trades",
                MSG_TYPE_MONITOR_TODAY_OPENED_LARGE_PNL: "Large PNL",
                // Large_Exposure: "Large_Exposure",
                // Cross_Account_Hedging: "Cross_Account_Hedging",
                MSG_TYPE_MONITOR_LOW_LIQUIDITY_ARBITRAGE:
                    "Low Liquidity Arbitrage",
                // New_Deposit: "New_Deposit",
                // New_Trade: "New_Trade",
            },
            bookFilterMenu: false,
            selectedBooks: [],
            commentData: {},
            commentModal: false,
            commentLoading: false,
        };
    },
    computed: {
        ...mapState("SettingsBooks", ["bookData"]),
        bookOptions() {
            return this.bookData
                .filter((book) => book.book_name !== "All")
                .map((book) => book.book_name);
        },
    },
    watch: {
        offset() {
            this.handleChange();
        },
        currentPage() {
            this.handleChange();
        },
        sortBy() {
            this.handleChange();
        },
        sortDesc() {
            this.handleChange();
        },
        triggered(nv) {
            if (nv) {
                this.handleChange();
            }
        },
        refresh() {
            this.handleChange();
        },
        selectedDate() {
            this.currentPage = 1;
            this.handleChange();
        },
        selectedStatus() {
            this.currentPage = 1;
            this.handleChange();
        },
        data() {
            this.$nextTick(this.updateStickyOffsets);
        },
        commentModal(nv) {
            if (!nv) {
                this.commentData = {};
            } else {
                this.getLastComment();
            }
        },
    },
    methods: {
        showCommentTooltip(event, item) {
            const rect = event.target.getBoundingClientRect();
            this.commentTooltip = {
                visible: true,
                text: `${item.comment} - ${item.comment_by} (${item.last_comment_time})`,
                x: rect.left + rect.width / 2,
                y: rect.top - 2,
            };
        },
        hideCommentTooltip() {
            this.commentTooltip.visible = false;
        },
        ...mapActions("AlertHub", ["updateTriggerStatus"]),
        ...mapActions("SettingsBooks", ["getBooksAction"]),
        onSearch(field) {
            setTimeout(() => {
                this.$refs[field].focus();
            }, 200);
        },
        toggleAlert(alertName) {
            const index = this.selectedAlerts.indexOf(alertName);
            if (index > -1) {
                this.selectedAlerts.splice(index, 1);
            } else {
                this.selectedAlerts.push(alertName);
            }
        },
        toggleBook(bookName) {
            const index = this.selectedBooks.indexOf(bookName);
            if (index > -1) {
                this.selectedBooks.splice(index, 1);
            } else {
                this.selectedBooks.push(bookName);
            }
        },
        handleChange() {
            clearTimeout(this.fetchTimeout);

            this.fetchTimeout = setTimeout(() => {
                clearInterval(this.interval);
                this.fetchTableData();
                this.interval = setInterval(() => this.fetchTableData(), 60000);
            }, 100);
        },
        fetchTableData() {
            if (this.fetched && this.$route.path === "/alert-hub-upgrade") {
                this.fetched = false;
                this.loading = true;
                const params = {
                    history: true,
                    startOfDay: this.selectedDate + " 00:00:00",
                    selected_alert:
                        this.selectedAlerts.length > 0
                            ? this.selectedAlerts
                            : undefined,
                    offset: this.offset,
                    currentPage: this.currentPage,
                    sort_by:
                        typeof this.sortBy === "object" &&
                        this.sortBy.length > 0
                            ? this.sortBy[0]
                            : undefined,
                    sortDesc: this.sortDesc,
                    login_filter: this.loginSearch,
                    book_filter:
                        this.selectedBooks.length > 0
                            ? this.selectedBooks
                            : undefined,
                    selected_status: this.selectedStatus ?? undefined,
                };
                getAlertHubUpgradeHistoryData(params)
                    .then((res) => {
                        res.data.data.map(
                            (item) =>
                                (item.mappedAlertType =
                                    this.type_mapping[item.alert_type])
                        );
                        this.data = res.data.data;
                        this.dataAmount = res.data.count;
                        this.loading = false;
                        this.fetched = true;
                    })
                    .catch(() => {
                        this.fetched = true;
                        this.loading = false;
                    });
            }
        },
        showAlertModal(alertDetail) {
            this.alertModal = true;
            this.alertDetail = alertDetail;
        },
        redirectTo(type, login, server, info, itemDetail) {
            let url = "";
            switch (type) {
                case "info":
                    url = `/tag-centre/account-analysis/${server}-${login}`;
                    redirectToRH(url);
                    break;
                case "add":
                    url = `/watch-list?mode=add&login=${login}&server=${server}`;
                    redirectToRH(url);
                    break;
                case "edit":
                    url = `/watch-list?mode=edit&login=${login}`;
                    redirectToRH(url);
                    break;
                case "view":
                    this.watchlistData = info;
                    this.watchlistModal = true;
                    break;
                case "comment":
                    this.commentLoading = true;
                    this.commentData = itemDetail;
                    this.commentModal = true;
                    break;
                default:
                    break;
            }
        },
        alertLevelClass(level) {
            const map = {
                1: "alert-level-2",
                2: "alert-level-1",
            };
            return map[level] || "";
        },
        convertAlertLevel(level) {
            const map = {
                1: "2",
                2: "1",
            };
            return map[level] || "";
        },
        updateStickyOffsets() {
            const thead = this.$el.querySelector("thead tr");
            if (!thead) return;
            const ths = thead.querySelectorAll("th");
            const len = ths.length;
            if (len < 3) return;
            const lastW = ths[len - 1].offsetWidth;
            const secondLastW = ths[len - 2].offsetWidth;
            this.$el.style.setProperty("--sticky-right-2", `${lastW}px`);
            this.$el.style.setProperty(
                "--sticky-right-3",
                `${lastW + secondLastW}px`
            );
        },
        getLastComment() {
            fetchLastComment({
                login: this.commentData.login,
                server_id: this.commentData.server_id,
            })
                .then((res) => {
                    this.commentData.last_comment = res.data.last_comment;
                    this.commentData.last_comment_by = res.data.last_comment_by;
                    this.commentData.last_comment_time =
                        res.data.last_comment_time;
                })
                .catch(() => {
                    this.commentData.last_comment = "";
                    this.commentData.last_comment_by = "";
                    this.commentData.last_comment_time = "";
                })
                .finally(() => {
                    this.commentLoading = false;
                });
        },
        onCommentChange() {
            this.commentLoading = true;
            changeHistoryComment({
                id: this.commentData.id,
                comment: this.commentData.comment,
                comment_by: localStorage.getItem("user_id"),
            })
                .then((res) => {
                    this.snackBarSuccess(res.data.msg);
                    this.commentModal = false;
                    this.handleChange();
                })
                .catch((err) => {
                    this.snackBarDanger(err.response.data.msg);
                })
                .finally(() => {
                    this.commentLoading = false;
                });
        },
    },
    created() {
        this.selectedAlerts = deepClone(this.defaultAlertTypes);
        this.getBooksAction();
    },
    mounted() {
        this.$nextTick(this.updateStickyOffsets);
        window.addEventListener("resize", this.updateStickyOffsets);
    },
    destroyed() {
        clearInterval(this.interval);
        window.removeEventListener("resize", this.updateStickyOffsets);
    },
};
</script>

<style scoped>
.comment-tooltip-fixed {
    position: fixed;
    transform: translateX(-50%) translateY(-100%);
    background-color: rgba(97, 97, 97, 0.9);
    color: #fff;
    padding: 5px 8px;
    border-radius: 4px;
    font-size: 12px;
    white-space: nowrap;
    pointer-events: none;
    z-index: 9999;
}

.login-cell {
    display: flex;
    align-items: center;
    gap: 4px;
}

.onboard-dot {
    display: inline-block;
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background-color: #df4343;
    flex-shrink: 0;
    cursor: default;
}

.name-cell,
.comment-cell {
    display: block;
    max-width: 70px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.alert-level-1,
.alert-level-2 {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 99%;
    height: 100%;
    font-weight: 600;
}
.alert-level-1 {
    background-color: #f44336;
    color: #fff;
}
.alert-level-2 {
    background-color: #ffeb3b;
    color: #000;
}

::v-deep(td:has(.alert-level-1)),
::v-deep(td:has(.alert-level-2)),
::v-deep(td:has(.alert-level-3)) {
    padding: 0 !important;
}

::v-deep(.v-data-table > .v-data-table__wrapper > table > thead > tr > th),
::v-deep(.v-data-table > .v-data-table__wrapper > table > tbody > tr > td) {
    padding: 0 8px; /* Top/Bottom, Left/Right */
}
</style>
